import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=cfa2916e&scoped=true&"
import script from "./Statistics.vue?vue&type=script&lang=ts&"
export * from "./Statistics.vue?vue&type=script&lang=ts&"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=cfa2916e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa2916e",
  null
  
)

export default component.exports